const projects = [
    {
        projectName: "TechAlley",
        description: "Platform combines cutting-edge technologies and industry best practices to deliver an exceptional shopping experience to headphone enthusiasts around the world.",
        image: "",
        isInProgress: true,
        skills: [".NET", "React.js", "MSSQL", "MongoDb", "Redis", "AWS S3 Bucket", "RabbitMQ", "Docker"],
        github: "https://github.com/DenisSemko/TechAlley",
        source: "https://github.com/DenisSemko/TechAlley"
    },
    {
        projectName: "CryptoTraceHub",
        description: "The real-time crypto currency information platform offers up-to-the-minute data and insights on a wide range of digital currencies, enabling users to track market prices.",
        image: "",
        isInProgress: true,
        skills: [".NET", "React.js", "Azure Cosmos Db", "ElasticSearch", "CoinMarketCapAPI", "RabbitMQ", "Docker"],
        github: "https://github.com/DenisSemko/CryptoTraceHub",
        source: "https://github.com/DenisSemko/CryptoTraceHub"
    },
    {
        projectName: "ChapterOne",
        description: "Software system for automating the process of searching and selecting books to create your own online library.",
        image: "/assets/Screenshot_1.png",
        isInProgress: false,
        skills: [".NET", "Angular", "MSSQL", "MSTest"],
        github: "https://github.com/DenisSemko/ChapterOne",
        source: "https://github.com/DenisSemko/ChapterOne"
    },
    {
        projectName: "YouthCare",
        description: "Software system for automation of health control in youth sports.",
        image: "/assets/Screenshot_2.png",
        isInProgress: false,
        skills: [".NET", "Angular", "MSSQL", "MSTest", "ASP.NET Identity"],
        github: "https://github.com/DenisSemko/YouthCare",
        source: "https://github.com/DenisSemko/YouthCare"
    },
    {
        projectName: "SportSections",
        description: "Windows desktop application combines different workarounds to have knowledge about university's sport sections.",
        image: "/assets/Screenshot3.png",
        isInProgress: false,
        skills: [".NET", "Winforms", "MSSQL"],
        github: "https://github.com/DenisSemko/SportSections",
        source: "https://github.com/DenisSemko/SportSections"
    }
];

export default projects;